module.exports = __webpack_public_path__ + "static/media/关于融云.63377c8a.png";